var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "title",
                    label: "标题",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.model.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "title", $$v)
                      },
                      expression: "model.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "content",
                    label: "内容",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入内容" },
                    model: {
                      value: _vm.model.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "content", $$v)
                      },
                      expression: "model.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "imgUrl",
                    label: "图片",
                  },
                },
                [
                  _c("j-image-upload", {
                    attrs: { text: "上传图片", isMultiple: true },
                    model: {
                      value: _vm.model.imgUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "imgUrl", $$v)
                      },
                      expression: "model.imgUrl",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }